import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { QuickOrderProductItemComponent } from '../quick-order-product-item/quick-order-product-item.component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'quick-order-product-list',
  standalone: true,
  imports: [CommonModule, QuickOrderProductItemComponent],
  templateUrl: './quick-order-product-list.component.html',
  styleUrl: './quick-order-product-list.component.scss',
})
export class QuickOrderProductListComponent {
  @Input() entries: OrderEntry[] = [];
  @Input() form!: FormGroup;
}
